import React from 'react';
import { Row, Col, Button } from 'react-bootstrap5';
import { useNavigate } from 'react-router-dom';

import routes from 'app/routes';
import usePrograms from 'components/Common/Members/Hooks/usePrograms';

import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';
import Section from './Section';

export default function Index() {
  const navigate = useNavigate();
  const programs = usePrograms();

  const homeContext = useHomeContext();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Programs',
    },
  ];

  const buildProgram = () => {
    navigate(routes.members.programs.chooseType);
  };

  const assignedPrograms = programs && programs.filter((program) => program.attributes.state === 'Assigned');
  const inProgressPrograms = programs && programs.filter((program) => program.attributes.state === 'In Progress');
  const completedPrograms = programs && programs.filter((program) => program.attributes.state === 'Completed');

  return (
    <div className="content">
      {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
      <section>
        <Row>
          <Col md={8}>
            <h1>My Programs</h1>
          </Col>

          <Col md={4} className="text-md-end">
            <Button
              onClick={() => buildProgram()}
              className="mt-3 mt-md-0"
            >
              Build New Program
            </Button>
          </Col>
        </Row>
      </section>

      <Section
        title="Assigned"
        programs={assignedPrograms}
      >
        All your personalized Talent Development programs that are ready for you to
        begin will be listed here. You can create and customize your own development plan or
        start programs assigned by your manager. These programs are designed to foster your
        professional growth and build your key skills.
      </Section>

      <Section
        title="In Progress"
        programs={inProgressPrograms}
      >
        Programs you&apos;ve started and are currently working on will appear here.
        Your tailored Development Plan will guide you step by step toward achieving
        your professional goals. View your progress, review milestones, and see the next
        steps on your development journey.
      </Section>

      <Section
        title="Completed"
        programs={completedPrograms}
      >
        Congratulations on completing your programs!
        This section showcases your accomplishments.
        You can review your coaching history and revisit details of your completed
        development plans to reflect on your growth and apply the insights gained.
      </Section>

    </div>
  );
}
